import React from 'react'

import { LeftImageContent, NoImageContent, TopImageContent } from '..'
import { SectionProps } from '../../../../core/types/Help'
import { List, SectionTitle, Text } from '../ContentItem'
import { HELP_IMAGES } from '../../../constants/HelpImages'
import { buildDynamicCopy } from '../../../../core/utils/Localization'

const NetWorth: React.FC<SectionProps> = ({ copy, topicKey }) => {
  const { networth_overview: netWorthCopyContent } = copy
  const dynamicGoalsSection = {
    'net-worth-overview': (
      <React.Fragment>
        <TopImageContent
          altImage={netWorthCopyContent.alt_image_net_worth_overview}
          content={
            <Text
              content={
                buildDynamicCopy(
                  netWorthCopyContent.net_worth_widget_overview_text,
                  <b>{netWorthCopyContent.accounts_bold_text}</b>,
                ) as React.ReactNode
              }
            />
          }
          image={HELP_IMAGES.NETWORTH_WIDGET}
          imageLargeBreakPoint={8}
          sx={{ mt: 24 }}
        />

        <NoImageContent
          content={
            <React.Fragment>
              <SectionTitle
                content={netWorthCopyContent.net_worth_history_section_title}
                sx={{ pt: 48 }}
              />
              <Text
                content={
                  buildDynamicCopy(
                    netWorthCopyContent.net_worth_history_step1,
                    <b>{netWorthCopyContent.dates_bold_text}</b>,
                  ) as React.ReactNode
                }
              />
              <Text content={netWorthCopyContent.net_worth_history_step2} />
            </React.Fragment>
          }
        />

        <SectionTitle content={netWorthCopyContent.gains_losses_section_title} sx={{ mt: 36 }} />
        <LeftImageContent
          altImage={netWorthCopyContent.alt_image_gains_losses}
          content={
            <React.Fragment>
              <Text
                content={
                  buildDynamicCopy(
                    netWorthCopyContent.gains_losses_subheader,
                    <b>{netWorthCopyContent.monthly_totals_bold_text}</b>,
                  ) as React.ReactNode
                }
              />
              <List
                items={[
                  buildDynamicCopy(
                    netWorthCopyContent.gains_losses_step1,
                    <b>{netWorthCopyContent.gains_bold_text}</b>,
                  ) as React.ReactNode,
                  buildDynamicCopy(
                    netWorthCopyContent.gains_losses_step2,
                    <b>{netWorthCopyContent.losses_bold_text}</b>,
                  ) as React.ReactNode,
                ]}
              />
            </React.Fragment>
          }
          image={HELP_IMAGES.NETWORTH_GAINS_LOSSES}
          imageLargeBreakPoint={3}
        />

        <SectionTitle
          content={netWorthCopyContent.assets_liabilities_section_title}
          sx={{ mt: 36 }}
        />
        <LeftImageContent
          altImage={netWorthCopyContent.alt_image_assets_liabilities}
          content={
            <React.Fragment>
              <Text content={netWorthCopyContent.assets_liabilities_subheader} />
              <List
                items={[
                  buildDynamicCopy(
                    netWorthCopyContent.assests_liabilities_step1,
                    <b>{netWorthCopyContent.assets_liabilities_section_title}</b>,
                  ) as React.ReactNode,
                  netWorthCopyContent.assests_liabilities_step2,
                ]}
                listType="ol"
              />
              <List
                items={[
                  buildDynamicCopy(
                    netWorthCopyContent.assets_definition,
                    <b>{netWorthCopyContent.assets_bold_text}</b>,
                  ) as React.ReactNode,
                  buildDynamicCopy(
                    netWorthCopyContent.liabilities_definition,
                    <b>{netWorthCopyContent.liabilities_bold_text}</b>,
                  ) as React.ReactNode,
                ]}
              />
            </React.Fragment>
          }
          hasDivider={false}
          image={HELP_IMAGES.NETWORTH_ASSETS_LIABILITIES}
          imageLargeBreakPoint={3}
        />
      </React.Fragment>
    ),
  }

  return dynamicGoalsSection[topicKey as keyof typeof dynamicGoalsSection]
}

export default NetWorth
